import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbIconComponent } from './cb-icon/cb-icon.component';



@NgModule({
  declarations: [
    CbIconComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CbIconComponent
  ]
})
export class CbIconModule { }
